/**
 * OCHAT: which sidebar entries this viewer may see.
 *
 * The list itself lives in config/reservedSections.js, which is also what the
 * route guard reads -- menu and URLs cannot disagree about what is reserved.
 *
 * THIS FILE IS PRESENTATION. The access control is elsewhere, and it does exist:
 *   - ochat/routes/routePermissionPolicy.js rewrites meta.permissions so
 *     upstream's own router guard redirects an administrator who types the URL
 *   - custom/app/policies/custom/*_policy.rb rejects the writes at the API, so a
 *     direct API call fails too
 * Reads are deliberately still open: the dashboard lists inboxes to render the
 * conversation view, and closing that would break the app for everyone.
 */
import { SUPER_ADMIN_PERMISSION } from './permissions';
import { RESERVED_SECTIONS, RESERVED_MENU_NAMES } from './reservedSections';

/**
 * name -> why it is reserved. The value is documentation; only the key matters.
 * Derived, so it cannot drift from the section list.
 */
export const SUPER_ADMIN_ONLY_ITEMS = Object.fromEntries(
  RESERVED_SECTIONS.flatMap(section =>
    section.menu.map(name => [name, section.why])
  )
);

/**
 * @param {string} name upstream's menu node name
 * @param {{permissions?: string[]}} viewer permissions for the active account, as
 *   published by AccountUser#permissions
 * @returns {boolean} whether this entry should render for this viewer
 */
export const isMenuItemVisible = (name, { permissions = [] } = {}) =>
  permissions.includes(SUPER_ADMIN_PERMISSION) ||
  !RESERVED_MENU_NAMES.includes(name);

/**
 * Kept as an alias because the spec and the docs refer to the old name, and
 * because "what is hidden" reads better than "what is reserved" at call sites
 * that only care about the default viewer.
 */
export const HIDDEN_MENU_ITEMS = SUPER_ADMIN_ONLY_ITEMS;
